import { OptionsApi } from '@core/swagger-client';
import { WebinarCampaignPage } from '@online-webinar/management';
import { RouterType } from '@online-webinar/router';
import { titleName } from '../components/DocumentTitle/routeTitle';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/$webinarId/marketing/$id'].update({
        staticData: {
            title: {
                name: titleName(
                    ({ webinarId, id }) => OptionsApi.marketingCampaigns.getDetail(webinarId, id),
                    (campaign) => campaign.name,
                    'Marketing.PageHeading'
                ),
                forWebinar: true
            }
        },
        component: authGuard(WebinarCampaignPage, { isWhitelabel: true, canManageEmailLists: true, canBroadcast: true })
    });
};
